import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';
import { useStyles } from './FavoriteButton.styles';
export const FavoriteTooltip = ({ open, content, onClose, placement = 'bottom', arrow = true, offset, isFavorited, children, }) => {
    const { classes } = useStyles();
    return (_jsx(Tooltip, { open: open, placement: placement, arrow: arrow, classes: {
            tooltip: classes.tooltip,
            arrow: classes.tooltipArrow,
            popper: isFavorited
                ? `${classes.customTooltipPopper} ${classes.customTooltipPopperFavorited}`
                : classes.customTooltipPopper,
        }, title: _jsxs("span", { className: classes.toolTipContent, children: [_jsx("span", { children: content.split('\n').map((line, i) => (_jsxs(React.Fragment, { children: [line, i < content.split('\n').length - 1 && _jsx("br", {})] }, `${line}_${i}`))) }), _jsx(CloseIcon, { fontSize: "small", className: classes.closeIcon, onClick: onClose })] }), children: children }));
};
